export default "__VITE_PUBLIC_ASSET__cd918325__"